/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Original_LabelInputs */



/**
* | output |
* | --- |
* | "Original media" |
*
* @param {Audio_Embed_Export_Original_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_original_label = /** @type {((inputs?: Audio_Embed_Export_Original_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Original_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Médias originaux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originalmedien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Materiale originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оригинальные медиа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios originales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原始媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルメディア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल मीडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia original")
	return /** @type {LocalizedString} */ ("Original media")
});